import React from "react";
import { useAuth } from "../../context/AuthContext";
import { useGetStudyByUserQuery } from "../../api/useGetStudyByUser";
import { Alert, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../utils/date";
import { SUBJECT } from "../../common/constants/subject";

const HomePage = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useGetStudyByUserQuery(
    currentUser?._id
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <Alert severity="error">{error.response.data.error}</Alert>;
  }

  return (
    <Stack alignItems="center" spacing={2} sx={{ mt: 4 }}>
      {data.length === 0 ? (
        <Alert>조인하신 스터디가 없습니다</Alert>
      ) : (
        data.map((study) => (
          <Button
            key={study._id}
            variant="contained"
            startIcon={
              <img
                src={`images/${
                  SUBJECT.find(
                    (subject) => subject.value === study.studyId.category
                  ).img
                }`}
                alt={study.studyId.category}
                style={{ width: 50, height: 50 }}
              />
            }
            sx={{
              width: { xs: "80%", md: "50%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => {
              navigate(`/study/${study.studyId._id}`);
            }}
          >
            <strong>{study.studyId.title}</strong>
            <span>{`${formatDate(study.studyId.startDate)} - ${formatDate(
              study.studyId.endDate
            )}`}</span>
          </Button>
        ))
      )}
    </Stack>
  );
};

export default HomePage;
